import { Helmet } from 'react-helmet';
import { FinanceToolsContainer } from '../components/finance-tools.container';

interface ISConfigFinanceToolsProps {}

export const ISConfigFinanceTools: React.FC<ISConfigFinanceToolsProps> = () => {
  return (
    <>
      <Helmet>
      <title>IS Config - Finance Tools</title>
      </Helmet>
      <FinanceToolsContainer />
    </>
  );
};
